import { useContext } from "react";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import RestrictionFilterDropdown from "@components/store/products/listing-header/filter-dropdown/restriction-filter-dropdown";
import FilterV2Dropdown from "@components/store/products/listing-header/filter-dropdown/filter-v2-dropdown";

import { useStoreContext } from "@components/store/provider";

const FilterDropdown = ({ filterConfig }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { isNewSwagmagicHost } = useStoreContext();

  const renderFilter = () => {
    if (isNewSwagmagicHost) {
      return <FilterV2Dropdown config={filterConfig} />;
    }
    return <RestrictionFilterDropdown isMobileDevice={isMobileDevice} />;
  };

  return isMobileDevice ? (
    <BottomIconHideWrapper>{renderFilter()}</BottomIconHideWrapper>
  ) : (
    renderFilter()
  );
};

export default FilterDropdown;
